import { api } from './api'

/**
 * 广场（公开曲谱）数据层。
 *
 * 广场是首页的附加栏目，**未登录访客也要能读** —— 所以
 * fetchPublicScores 不带登录态、取不到时静默返回空数组，
 * 整块不渲染。改这块时别顺手加上"未登录就跳过"的逻辑。
 */

export type PublicScore = {
	id: string
	title: string
	content: string
	/** 创建者署名（昵称或 'manmantan'）；点进编辑器保存副本时继承它 */
	creator: string | null
	/** 作者昵称（广场显示用；空则前端回落 creator / 邮箱前缀） */
	nickname: string | null
	/** 作者头像公开 URL；没有则显示昵称首字占位 */
	avatar_url: string | null
	updated_at: string | null
}

export async function fetchPublicScores(): Promise<PublicScore[]> {
	try {
		return (await api.get<PublicScore[]>('/plaza')) ?? []
	} catch (err) {
		console.warn('广场曲谱读取失败：', err)
		return []
	}
}

/** 切换某份曲谱的公开态（仅所有者；后端校验归属）。 */
export async function setScorePublic(scoreId: string, isPublic: boolean): Promise<void> {
	await api.post(`/scores/${scoreId}/public`, {is_public: isPublic})
}